<template>
  <div :class="`table-cell table-button table-button-${variant}`">
    <button
      :class="`btn btn-sm d-flex justify-content-center align-items-center ${textColor}`"
      @click="() => onClick(group)"
    >
      <span>{{ text }}</span>
      <!-- a<i v-if="icon" class="p-0" :class="icon"> </i> -->
    </button>
  </div>
</template>

<script>
export default {
  name: 'PulsTableButtonCell',
  props: {
    group: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'secondary',
      required: true
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      addRow: false
    }
  },
  computed: {
    textColor() {
      return this.variant === 'primary' ? 'text-white' : 'text-dark'
    }
  }
}
</script>

<style lang="scss">
.table-cell-title-arrow {
  transition: transform 0.2s ease;
  &.rotated {
    transform: rotate(90deg);
  }
}
.table-button-primary {
  background-color: var(--kt-primary);
}
.table-button-secondary {
  background-color: var(--kt-secondary);
}
</style>
